export const navigation = [
  {
    text: 'Queries',
    path: '/queries',
    icon: 'home'
  }
  ];
